import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminEnrollmentsLive: build.query<
      GetV2AdminEnrollmentsLiveApiResponse,
      GetV2AdminEnrollmentsLiveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/enrollments/live`,
        params: {
          include_history: queryArg.includeHistory,
        },
      }),
    }),
    getV2AdminEnrollmentsOrganizations: build.query<
      GetV2AdminEnrollmentsOrganizationsApiResponse,
      GetV2AdminEnrollmentsOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/enrollments/organizations`,
        params: {
          connected_within: queryArg.connectedWithin,
          search: queryArg.search,
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollments: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollments: build.mutation<
      PostV2AdminOrgsByOrganizationIdEnrollmentsApiResponse,
      PostV2AdminOrgsByOrganizationIdEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments`,
        method: "POST",
        body: queryArg.initiateEnrollmentRequest,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollmentsEvidence: build.mutation<
      PostV2AdminOrgsByOrganizationIdEnrollmentsEvidenceApiResponse,
      PostV2AdminOrgsByOrganizationIdEnrollmentsEvidenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/evidence`,
        method: "POST",
        body: queryArg.payerEvidenceRequest,
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollmentsLive: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsLiveApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsLiveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/live`,
        params: {
          include_history: queryArg.includeHistory,
        },
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollmentsStatus: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsStatusApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/status`,
        params: {
          include_history: queryArg.includeHistory,
        },
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollmentsSyncAll: build.mutation<
      PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiResponse,
      PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/sync-all`,
        method: "POST",
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentId: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/${queryArg.enrollmentId}`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSync:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiResponse,
        PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/${queryArg.enrollmentId}/sync`,
          method: "POST",
        }),
      }),
    getV2ProviderEnrollments: build.query<
      GetV2ProviderEnrollmentsApiResponse,
      GetV2ProviderEnrollmentsApiArg
    >({
      query: () => ({ url: `/v2/provider/enrollments` }),
    }),
    postV2ProviderEnrollments: build.mutation<
      PostV2ProviderEnrollmentsApiResponse,
      PostV2ProviderEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments`,
        method: "POST",
        body: queryArg.initiateEnrollmentRequest,
      }),
    }),
    getV2ProviderEnrollmentsLive: build.query<
      GetV2ProviderEnrollmentsLiveApiResponse,
      GetV2ProviderEnrollmentsLiveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/live`,
        params: {
          include_history: queryArg.includeHistory,
        },
      }),
    }),
    postV2ProviderEnrollmentsSyncAll: build.mutation<
      PostV2ProviderEnrollmentsSyncAllApiResponse,
      PostV2ProviderEnrollmentsSyncAllApiArg
    >({
      query: () => ({
        url: `/v2/provider/enrollments/sync-all`,
        method: "POST",
      }),
    }),
    getV2ProviderEnrollmentsByEnrollmentId: build.query<
      GetV2ProviderEnrollmentsByEnrollmentIdApiResponse,
      GetV2ProviderEnrollmentsByEnrollmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}`,
      }),
    }),
    postV2ProviderEnrollmentsByEnrollmentIdDocuments: build.mutation<
      PostV2ProviderEnrollmentsByEnrollmentIdDocumentsApiResponse,
      PostV2ProviderEnrollmentsByEnrollmentIdDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}/documents`,
        method: "POST",
        body: queryArg.uploadDocumentRequest,
      }),
    }),
    postV2ProviderEnrollmentsByEnrollmentIdSync: build.mutation<
      PostV2ProviderEnrollmentsByEnrollmentIdSyncApiResponse,
      PostV2ProviderEnrollmentsByEnrollmentIdSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}/sync`,
        method: "POST",
      }),
    }),
    postV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskId: build.mutation<
      PostV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskIdApiResponse,
      PostV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}/tasks/${queryArg.taskId}`,
        method: "POST",
        body: queryArg.completeTaskRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminEnrollmentsLiveApiResponse =
  /** status 200 OK */ CrossOrganizationLiveEnrollmentsResponse;
export type GetV2AdminEnrollmentsLiveApiArg = {
  /** Return every enrollment attempt per provider + payer + transaction rail. By default only the newest attempt per lineage is returned, whatever its status. */
  includeHistory?: boolean;
};
export type GetV2AdminEnrollmentsOrganizationsApiResponse =
  /** status 200 OK */ PayerLoadOrganizationsResponse;
export type GetV2AdminEnrollmentsOrganizationsApiArg = {
  connectedWithin?: "30d" | "90d" | "all" | "unknown";
  search?: string | null;
  page?: number;
  pageSize?: number;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentListResponse;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsApiArg = {
  organizationId: string;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsApiArg = {
  organizationId: string;
  initiateEnrollmentRequest: InitiateEnrollmentRequest;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsEvidenceApiResponse =
  /** status 200 OK */ PayerEvidenceResponse;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsEvidenceApiArg = {
  organizationId: string;
  payerEvidenceRequest: PayerEvidenceRequest;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsLiveApiResponse =
  /** status 200 OK */ LiveEnrollmentsResponse;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsLiveApiArg = {
  organizationId: string;
  /** Return every enrollment attempt per provider + payer + transaction rail. By default only the newest attempt per lineage is returned, whatever its status. */
  includeHistory?: boolean;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsStatusApiResponse =
  /** status 200 OK */ LiveEnrollmentStatusResponse;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsStatusApiArg = {
  organizationId: string;
  /** Return every enrollment attempt per provider + payer + transaction rail. By default only the newest attempt per lineage is returned, whatever its status. */
  includeHistory?: boolean;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiResponse =
  /** status 200 OK */ SyncAllResponse;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiArg = {
  organizationId: string;
  enrollmentId: string;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiArg =
  {
    organizationId: string;
    enrollmentId: string;
  };
export type GetV2ProviderEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentListResponse;
export type GetV2ProviderEnrollmentsApiArg = void;
export type PostV2ProviderEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2ProviderEnrollmentsApiArg = {
  initiateEnrollmentRequest: InitiateEnrollmentRequest;
};
export type GetV2ProviderEnrollmentsLiveApiResponse =
  /** status 200 OK */ LiveEnrollmentsResponse;
export type GetV2ProviderEnrollmentsLiveApiArg = {
  /** Return every enrollment attempt per provider + payer + transaction rail. By default only the newest attempt per lineage is returned, whatever its status. */
  includeHistory?: boolean;
};
export type PostV2ProviderEnrollmentsSyncAllApiResponse =
  /** status 200 OK */ SyncAllResponse;
export type PostV2ProviderEnrollmentsSyncAllApiArg = void;
export type GetV2ProviderEnrollmentsByEnrollmentIdApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type GetV2ProviderEnrollmentsByEnrollmentIdApiArg = {
  enrollmentId: string;
};
export type PostV2ProviderEnrollmentsByEnrollmentIdDocumentsApiResponse =
  /** status 200 OK */ UploadDocumentResponse;
export type PostV2ProviderEnrollmentsByEnrollmentIdDocumentsApiArg = {
  enrollmentId: string;
  uploadDocumentRequest: UploadDocumentRequest;
};
export type PostV2ProviderEnrollmentsByEnrollmentIdSyncApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2ProviderEnrollmentsByEnrollmentIdSyncApiArg = {
  enrollmentId: string;
};
export type PostV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskIdApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2ProviderEnrollmentsByEnrollmentIdTasksAndTaskIdApiArg = {
  enrollmentId: string;
  taskId: string;
  completeTaskRequest: CompleteTaskRequest;
};
export type LiveEnrollmentResponse = {
  created_at?: string | null;
  /** Generic evidence availability error */
  evidence_error: string | null;
  evidence_source: "received_835" | null;
  /** Production 835 claim-result evidence for this payer within caller scope. Legacy claim status alone is unconfirmed. False means no qualifying evidence found; null means the evidence read is incomplete. */
  has_received_claim: boolean | null;
  /** Payer display name, resolved via the payers catalog; falls back to the raw Stedi payer id when unresolved */
  payer_name?: string | null;
  /** Stedi enrollment portal URL, when Stedi's payload carries one */
  portal_url?: string | null;
  provider_npi?: string | null;
  rejection_reason?: string | null;
  /** Stedi's status verbatim: DRAFT, STEDI_ACTION_REQUIRED, PROVISIONING, PROVIDER_ACTION_REQUIRED, LIVE, REJECTED, CANCELED */
  status: string;
  status_message?: string | null;
  status_updated_at?: string | null;
  stedi_enrollment_id: string;
  stedi_payer_id?: string | null;
  /** Stedi provider record the enrollment belongs to; with the payer and transaction type it identifies one enrollment lineage */
  stedi_provider_id?: string | null;
  submitted_at?: string | null;
  /** 837P or 835 */
  transaction_type: string;
};
export type OrganizationLiveEnrollmentsResponse = {
  /** UTC timestamp when this response was generated; shared across every organization in one cross-organization read */
  checked_at: string;
  connected: boolean;
  enrollments?: LiveEnrollmentResponse[];
  /** Short, secret-free error message when the live read for this organization failed */
  error?: string | null;
  /** True for JotPsych's internal test organization; the roster uses this to hide it by default */
  is_internal_test?: boolean;
  organization_id: string;
  organization_name: string;
};
export type CrossOrganizationLiveEnrollmentsResponse = {
  /** UTC timestamp when this response was generated */
  checked_at: string;
  organizations?: OrganizationLiveEnrollmentsResponse[];
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type PayerLoadOrganizationResponse = {
  connected_at: string | null;
  organization_id: string;
  organization_name: string;
};
export type PayerLoadOrganizationsResponse = {
  effective_connected_within: "30d" | "90d" | "all" | "unknown";
  has_next_page: boolean;
  organizations?: PayerLoadOrganizationResponse[];
  page: number;
  page_size: number;
  search_overrides_date: boolean;
  total: number;
};
export type EnrollmentResponse = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  /** Outstanding Stedi tasks for this enrollment */
  tasks?: {
    [key: string]: any;
  }[];
  transaction_type: string;
  updated_at: string;
};
export type EnrollmentListResponse = {
  enrollments: EnrollmentResponse[];
};
export type EnrollmentResponse2 = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  /** Outstanding Stedi tasks for this enrollment */
  tasks?: {
    [key: string]: any;
  }[];
  transaction_type: string;
  updated_at: string;
};
export type InitiateEnrollmentRequest = {
  /** Billing entity to enroll */
  billing_entity_id: string;
  /** Internal payer UUID (from local database) */
  payer_uuid?: string | null;
  /** Stedi payer ID (from payer search results) */
  stedi_id?: string | null;
  /** Transaction type: 837P (claims) or 835 (ERA) */
  transaction_type?: string;
};
export type PayerReceiptEvidenceResponse = {
  evidence_error: string | null;
  evidence_source: "received_835" | null;
  has_received_claim: boolean | null;
  payer_id: string;
};
export type PayerEvidenceResponse = {
  evidence?: PayerReceiptEvidenceResponse[];
};
export type PayerEvidenceRequest = {
  payer_ids: string[];
};
export type LiveEnrollmentResponse2 = {
  created_at?: string | null;
  /** Generic evidence availability error */
  evidence_error: string | null;
  evidence_source: "received_835" | null;
  /** Production 835 claim-result evidence for this payer within caller scope. Legacy claim status alone is unconfirmed. False means no qualifying evidence found; null means the evidence read is incomplete. */
  has_received_claim: boolean | null;
  /** Payer display name, resolved via the payers catalog; falls back to the raw Stedi payer id when unresolved */
  payer_name?: string | null;
  /** Stedi enrollment portal URL, when Stedi's payload carries one */
  portal_url?: string | null;
  provider_npi?: string | null;
  rejection_reason?: string | null;
  /** Stedi's status verbatim: DRAFT, STEDI_ACTION_REQUIRED, PROVISIONING, PROVIDER_ACTION_REQUIRED, LIVE, REJECTED, CANCELED */
  status: string;
  status_message?: string | null;
  status_updated_at?: string | null;
  stedi_enrollment_id: string;
  stedi_payer_id?: string | null;
  /** Stedi provider record the enrollment belongs to; with the payer and transaction type it identifies one enrollment lineage */
  stedi_provider_id?: string | null;
  submitted_at?: string | null;
  /** 837P or 835 */
  transaction_type: string;
};
export type LiveEnrollmentsResponse = {
  /** UTC timestamp when this response was generated */
  checked_at: string;
  /** Whether the organization has a Stedi API key configured */
  connected: boolean;
  enrollments?: LiveEnrollmentResponse2[];
};
export type LiveEnrollmentStatusRow = {
  created_at?: string | null;
  payer_name?: string | null;
  portal_url?: string | null;
  provider_npi?: string | null;
  rejection_reason?: string | null;
  status: string;
  status_message?: string | null;
  status_updated_at?: string | null;
  stedi_enrollment_id: string;
  stedi_payer_id?: string | null;
  stedi_provider_id?: string | null;
  submitted_at?: string | null;
  transaction_type: string;
};
export type LiveEnrollmentStatusResponse = {
  checked_at: string;
  connected: boolean;
  enrollments?: LiveEnrollmentStatusRow[];
  error?: string | null;
};
export type EnrollmentResponse3 = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  /** Outstanding Stedi tasks for this enrollment */
  tasks?: {
    [key: string]: any;
  }[];
  transaction_type: string;
  updated_at: string;
};
export type SyncAllResponse = {
  enrollments: EnrollmentResponse3[];
  synced_count: number;
};
export type UploadDocumentResponse = {
  /** Stedi documentId to reference when completing the task */
  document_id: string;
};
export type UploadDocumentRequest = {
  /** MIME type of the file */
  content_type?: string;
  /** Base64-encoded file contents */
  data: string;
  /** Original file name, e.g. authorization.pdf */
  file_name: string;
};
export type CompleteTaskRequest = {
  /** Task field values: {key, value} for text fields, {key, documentId} for document fields */
  values?: {
    [key: string]: any;
  }[];
};
